import { Suspense, lazy } from 'react';

import { isLocalStorageDevtoolsEnabled } from '../../utils/localStorageDevFeatures';

const shouldLoad = import.meta.env.DEV || isLocalStorageDevtoolsEnabled();

const DevtoolsInner = shouldLoad
  ? lazy(() =>
      import('./DevtoolsPanels').then(m => ({
        default: m.DevtoolsPanels,
      }))
    )
  : () => null;

export const Devtools = () => (
  <Suspense fallback={null}>
    <DevtoolsInner />
  </Suspense>
);
